import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class SetPwdService {
  static verifyInvitation(param) {
    return HttpUtil.uniterceptedGet(API_ROUTES.SETPWD.INVITATIONVERIFY+`/${param}/verify`);
  }

  static createPassword(param) {
    return HttpUtil.uniterceptedPost(API_ROUTES.SETPWD.SETNEWPASSWORD,param);
  }
 
}
